
export const MEMBER_MEMBERSHIP_LOADING = 'REDUX_SAGA_MEMBER_MEMBERSHIP_LOADING';
export const MEMBER_MEMBERSHIP_SUCCESS = 'REDUX_SAGA_MEMBER_MEMBERSHIP_SUCCESS';
export const MEMBER_MEMBERSHIP_ERROR = 'REDUX_SAGA_MEMBER_MEMBERSHIP_ERROR';
export const RESET_MEMBER_MEMBERSHIP = 'REDUX_SAGA_RESET_MEMBER_MEMBERSHIP';

export const actionGetMemberMemberships = (dispatch, customerId) => {
    dispatch({ type: MEMBER_MEMBERSHIP_LOADING, customerId: customerId });
};
